import { IRace } from '../../../models/IRace';
import { Component, OnInit } from '@angular/core';
import { NascarService } from '../../../services/nascar.service';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseService } from '../../../services/base.service';
import { AdminService } from '../../../services/admin.service';


@Component({
  selector: 'app-createrace',
  templateUrl: './createrace.component.html',
  styleUrls: ['./createrace.component.scss']
})
export class CreateRaceComponent implements OnInit {


  public isRequesting = false;
  public raceExists = false;
  public lastRace: IRace;
  public model: IRace;
  public raceEvent: Subscription;
  public form: FormGroup;
  private validationMessages: {
    required: 'is required',
    dateFormat: ' valid date format '
    nascarRaceId: 'Race Id ',
    name: 'Name ',
    weekNumber: 'Week Number ',
    startDateTime: 'Start Date ',
    season: 'Season ',
    location: 'Location '
  }
  constructor(private adminService: AdminService,
    private baseService: BaseService,
    private nascarService: NascarService,
    private fb: FormBuilder) {

  }

  ngOnInit() {

    this.nascarService.getCurrentNascarRace().subscribe(race => {
        this.nascarService.getLastRace().subscribe(lastRace => {
          
          this.lastRace = lastRace;
          if (race.nascarRaceId === lastRace.nascarRaceId)
            this.raceExists = true;
          else
            this.raceExists = false;
          this.form = this.fb.group({
            id:  [race.id],
            nascarRaceId: [race.nascarRaceId, Validators.required],
            name: [race.name, Validators.required],
            weekNumber: [race.weekNumber, Validators.required],
            startDateTime: [this.baseService.getLocalTimeFromUtc(race.startDateTime), Validators.required],
            season: [race.season, Validators.required],
            location: [race.location, Validators.required]
          });
        });
      //this.lastRace = race;

      //this.onChanges();
    });
  }

  // onChanges(): void {
  //   this.form.valueChanges.subscribe(val => {
  //     this.raceExists = false;
  //   });
  // }


  save() {
    //console.log(this.model);
    //console.log('Saved: ' + JSON.stringify(this.model));
    this.isRequesting = true;

    if (this.form.valid) {
      this.adminService.upsertRace(this.form.value).subscribe(result => {
        this.model = result;
        this.baseService.toasterService.pop('info', 'Save', 'SaveCompleted');
        this.isRequesting = false;
      })
    }
  }
}




// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/nascar/createrace/createrace.component.ts